import { defineComponent as _defineComponent } from 'vue'
import { watch, computed } from 'vue';
import store from '@/store';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';
import MapStylePropertiesCreateThumbnail from '@/components/DesignStudio/MapStyleProperties/components/create/thumbnail/MapStylePropertiesCreateThumbnail.vue';
import MapStylePropertiesCreateHeader from '@/components/DesignStudio/MapStyleProperties/components/create/header/MapStylePropertiesCreateHeader.vue';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';

interface Emits {
    (event: 'create', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStylePropertiesCreate',
  emits: ["create"],
  setup(__props, { emit }: { emit: ({
    (event: 'create', value: string): void;
}), expose: any, slots: any, attrs: any }) {



const isOpen = computed(() => {
    return store.state.mapStyleProperties?.modalAddIsOpen || false;
});

const filteredPresets = computed(() => {
    const searchQuery = store.state.mapStyleProperties?.searchQuery.toLowerCase() || '';
    return store.state.mapStyleProperties?.searchQuery
        ? MAP_STYLE_PRESETS.filter((preset) => preset.label.toLowerCase().includes(searchQuery))
        : MAP_STYLE_PRESETS;
});

const handleClose = () => {
    store?.dispatch('mapStyleProperties/closeAddModal');
};

const resetForm = () => {
    store.dispatch('mapStyleProperties/resetModalState');
};

const handlePresetSelect = (preset: MapStylePresetType) => {
    emit('create', preset.value);
    handleClose();
};

watch(
    () => isOpen.value,
    () => {
        if (!isOpen.value) {
            resetForm();
        }
    }
);

return { __sfc: true,emit, isOpen, filteredPresets, handleClose, resetForm, handlePresetSelect, CModal, CButton, MapStylePropertiesCreateThumbnail, MapStylePropertiesCreateHeader }
}

})